angular.module('mercury.modules.thirdparty.intercom', []);